export default "__VITE_ASSET__BYcUm46i__"